import { reviewFormDataDbWriteValidator } from "@redotech/redo-model/form-builder-form/db-validator/review/review-form-builder-form-db-validator";
import * as z from "zod";

export const createDefaultReviewForm = {
  name: "createDefaultReviewForm" as const,
  input: z.object({
    teamId: z.string(),
    formData: reviewFormDataDbWriteValidator,
  }),
  output: z.null(),
};
